<template>
	<el-dialog
		title="Select User"
		:visible.sync="dialogVisible"
		width="800px"
		append-to-body
		@close="handleDialogClose"
	>
		<div class="user_dialog">
			<el-input
				v-model="searchKeyword"
				placeholder="Search by name"
				clearable
				class="search_input"
			>
				<i slot="prefix" class="el-input__icon el-icon-search"></i>
			</el-input>

			<el-table
				ref="userTable"
				:data="pagedUserList"
				height="300"
				border
				row-key="id"
				@selection-change="handleSelectionChange"
			>
				<el-table-column
					type="selection"
					width="55"
					:reserve-selection="true"
					align="center"
				/>

				<el-table-column
					prop="user_id"
					label="User ID"
					width="120"
				/>

				<el-table-column
					prop="username"
					label="User Name"
					width="140"
				/>

				<!-- <el-table-column
					prop="company"
					label="Company"
				>
					<template slot-scope="scope">
						{{ scope.row.company_name || "/" }}
					</template>
				</el-table-column> -->

				<el-table-column
					prop="dept"
					label="Department"
				>
					<template slot-scope="scope">
						{{ scope.row.departments_name || "/" }}
					</template>
				</el-table-column>
			</el-table>

			<div v-if="!filteredList.length" class="empty_text">
				No matching users found.
			</div>

			<div class="pagination" v-if="filteredList.length">
				<el-pagination
					background
					layout="total, sizes, prev, pager, next"
					:total="filteredList.length"
					:page-size="pageSize"
					:page-sizes="[5, 10, 20, 50]"
					:current-page.sync="currentPage"
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
				/>
			</div>

			<div class="footer_btns">
				<el-button @click="dialogVisible = false">
					Cancel
				</el-button>

				<el-button type="primary" @click="handleConfirm">
					Confirm
				</el-button>
			</div>
		</div>
	</el-dialog>
</template>

<script>
	export default {
		name: "UserSelectDialog",
		props: {
			visible: Boolean,
			userList: {
				type: Array,
				default: () => [],
			},
			selectedIds: {
				type: Array,
				default: () => [],
			},
		},

		data() {
			return {
				dialogVisible: false,
				searchKeyword: "",
				pageSize: 5,
				currentPage: 1,
				tempSelectedIds: [],
				tempSelectedUsers: [],
				isRestoringSelection: false,
			};
		},

		computed: {
			filteredList() {
				const keyword = this.searchKeyword.trim().toLowerCase();
				if (!keyword) return this.userList;

				return this.userList.filter((item) => {
					const name = String(item.username || "")
						.trim()
						.toLowerCase();
					return name.includes(keyword);
				});
			},

			pagedUserList() {
				const start = (this.currentPage - 1) * this.pageSize;
				return this.filteredList.slice(start, start + this.pageSize);
			},
		},

		watch: {
			visible: {
				immediate: true,
				handler(val) {
					this.dialogVisible = val;
					if (val) {
						this.currentPage = 1;
						this.tempSelectedIds = [...this.selectedIds];

						// 根据 selectedIds 回显已选中的用户对象
						this.tempSelectedUsers = this.userList.filter((item) =>
							this.selectedIds.includes(item.id)
						);

						this.$nextTick(() => {
							this.restoreSelection();
						});
					}
				},
			},

			dialogVisible(val) {
				this.$emit("update:visible", val);
			},

			selectedIds(val) {
				if (this.dialogVisible) {
					this.tempSelectedIds = [...val];
					this.tempSelectedUsers = this.userList.filter((item) =>
						val.includes(item.id)
					);

					this.$nextTick(() => {
						this.restoreSelection();
					});
				}
			},

			searchKeyword() {
				this.currentPage = 1;
				this.$nextTick(() => {
					this.restoreSelection();
				});
			},

			pagedUserList() {
				this.$nextTick(() => {
					this.restoreSelection();
				});
			},
		},

		methods: {
			handleSelectionChange(selection) {
				if (this.isRestoringSelection) return;
				const currentPageIds = this.pagedUserList.map((item) => item.id);
				this.tempSelectedUsers = this.tempSelectedUsers.filter(
					(item) => !currentPageIds.includes(item.id)
				);
				this.tempSelectedUsers = [...this.tempSelectedUsers, ...selection];
				const map = new Map();
				this.tempSelectedUsers.forEach((item) => {
					map.set(item.id, item);
				});
				this.tempSelectedUsers = Array.from(map.values());
				this.tempSelectedIds = this.tempSelectedUsers.map((item) => item.id);
			},

			restoreSelection() {
				if (!this.$refs.userTable) return;
				this.isRestoringSelection = true;
				this.$refs.userTable.clearSelection();
				this.pagedUserList.forEach((row) => {
					if (this.tempSelectedIds.includes(row.id)) {
						this.$refs.userTable.toggleRowSelection(row, true);
					}
				});
				this.$nextTick(() => {
					this.isRestoringSelection = false;
				});
			},

			handleConfirm() {
				this.$emit("confirm", {
					ids: this.tempSelectedIds,
					users: this.tempSelectedUsers,
				});
				this.dialogVisible = false;
			},

			handleDialogClose() {
				this.searchKeyword = "";
				this.currentPage = 1;
			},

			handleSizeChange(size) {
				this.pageSize = size;
				this.currentPage = 1;
			},

			handleCurrentChange(page) {
				this.currentPage = page;
			},
		},
	};
</script>

<style lang="less" scoped>
	.user_dialog {
		.search_input {
			margin-bottom: 15px;
		}

		.pagination {
			margin-top: 10px;
			text-align: right;
		}

		.empty_text {
			text-align: center;
			color: #999;
			padding: 20px 0;
		}

		.footer_btns {
			margin-top: 20px;
			text-align: right;
		}
	}
</style>